import { render } from "./Investment.vue?vue&type=template&id=1d64b5cd"
import script from "./Investment.vue?vue&type=script&setup=true&lang=js"
export * from "./Investment.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/frontend/components/Investment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d64b5cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d64b5cd', __exports__)) {
    console.log('reload')
    api.reload('1d64b5cd', __exports__)
  }
  
  module.hot.accept("./Investment.vue?vue&type=template&id=1d64b5cd", () => {
    console.log('re-render')
    api.rerender('1d64b5cd', render)
  })

}


export default __exports__